import React from 'react';
import LanguagePicker from '~/components/LanguagePicker';
import { AppLocale } from '~/data/models/app';
import { TabScreenLayout } from '~/screens/style';
import { t } from '~/utils/i18n';
import { Content } from './style';

type AppSetupLayoutProps = {
  selectedLocale?: AppLocale;
  onBack: () => void;
  onUpdateLocale: (locale: AppLocale) => void;
};

export default function AppSetup({
  selectedLocale = 'auto',
  onBack,
  onUpdateLocale,
}: AppSetupLayoutProps): JSX.Element {
  return (
    <TabScreenLayout
      backButtonTestID={'buttonBack'}
      title={t('screens.appSetUp')}
      onBackPress={onBack}
    >
      <Content>
        {selectedLocale ? (
          <LanguagePicker
            testID={'languagePicker'}
            label={t('g.appLocale')}
            selectedLocale={selectedLocale}
            onSelectedLocale={(language) => {
              onUpdateLocale(language);
            }}
          />
        ) : null}
      </Content>
    </TabScreenLayout>
  );
}
